"use strict";
module.exports = function (config, get, post) {
  return {
    create: (modelId, items) => post("/v2/kit/create", { modelId, items }),

    state: (kitId, toState) => post("/v2/kit/state", { kitId, toState }),

    destroy: (kitId) => post("/v2/kit/delete", { kitId }),

    kits: (query, pagination) => get("/v2/kit/kits", { query, pagination }),

    models: (query, pagination) => get("/v2/kit/models", { query, pagination }),

    model: {
      create: (modelNumber, modelName, itemModels) =>
        post("/v2/kit/model/create", { modelNumber, modelName, itemModels }),

      update: (modelId, update) =>
        post("/v2/kit/model/update", { modelId, update }),

      destroy: (modelId) => post("/v2/kit/model/delete", { modelId }),
    },

    assignments: (query, pagination) =>
      get("/v2/kit/assignments", { query, pagination }),

    request: (kitRequest) => post("/v2/kit/assignment/request", { kitRequest }),

    assignment: {
      update: (assignmentId, update) =>
        post("/v2/kit/assignment/update", { assignmentId, update }),

      cancel: (assignmentId) =>
        post("/v2/kit/assignment/cancel", { assignmentId }),
    },
  };
};
